// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"37":"b0daea01fc046fff87d6","446":"077d1fd7ce12bbe350f4","540":"55353bb8d71a0fe26479","961":"55ebcfddd3366a78c394"}[chunkId] + ".js";
};